/**
 * Flavortown Product Showcase — video behavior
 * Mobile: autoplay as card scrolls into view (smooth, continuous detection).
 * Desktop: play on hover, reset to beginning on mouseout.
 * Videos play once, then reset. Retrigger by scrolling or hovering again.
 */
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 1200;
  var VISIBILITY_THRESHOLD = 0.4;

  function isDesktop() {
    return window.innerWidth >= MOBILE_BREAKPOINT;
  }

  function setupLoadingStates(media, video) {
    video.addEventListener('waiting', function () {
      media.classList.add('is-loading');
      media.classList.remove('is-ready');
    });

    video.addEventListener('canplay', function () {
      media.classList.remove('is-loading');
      media.classList.add('is-ready');
    });

    if (video.readyState >= 3) {
      media.classList.add('is-ready');
    }

    // When video ends, reset to show the image again
    video.addEventListener('ended', function () {
      video.currentTime = 0;
      media.classList.remove('is-playing');
      media.classList.remove('is-loading');
    });
  }

  function playVideo(media, video) {
    // Allow retrigger — only skip if actively playing right now
    if (!video.paused && !video.ended) return;

    video.currentTime = 0;
    media.classList.add('is-loading');
    var playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then(function () {
          media.classList.remove('is-loading');
          media.classList.add('is-playing');
        })
        .catch(function () {
          media.classList.remove('is-loading');
        });
    } else {
      media.classList.add('is-playing');
    }
  }

  function stopVideo(media, video) {
    video.pause();
    video.currentTime = 0;
    media.classList.remove('is-playing');
    media.classList.remove('is-loading');
  }

  function getVisibleRatio(el) {
    var rect = el.getBoundingClientRect();
    var viewportHeight = window.innerHeight;

    if (rect.bottom <= 0 || rect.top >= viewportHeight) return 0;

    var visibleTop = Math.max(0, rect.top);
    var visibleBottom = Math.min(viewportHeight, rect.bottom);
    var visibleHeight = visibleBottom - visibleTop;

    return visibleHeight / rect.height;
  }

  function initShowcase(section) {
    var cards = section.querySelectorAll('.ft-showcase__media');
    if (!cards.length) return;

    var videoCards = [];
    cards.forEach(function (media) {
      var video = media.querySelector('video');
      if (!video) return;

      setupLoadingStates(media, video);
      videoCards.push({ media: media, video: video });

      // ── Desktop: hover play / mouseout reset ──
      media.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        playVideo(media, video);
      });

      media.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        stopVideo(media, video);
      });
    });

    if (!videoCards.length) return;

    // ── Mobile: scroll-based continuous detection ──
    var currentlyPlaying = null;
    var ticking = false;

    function onScrollCheck() {
      if (isDesktop()) return;

      var bestCard = null;
      var bestRatio = 0;

      videoCards.forEach(function (item) {
        var ratio = getVisibleRatio(item.media);
        if (ratio >= VISIBILITY_THRESHOLD && ratio > bestRatio) {
          bestRatio = ratio;
          bestCard = item;
        }
      });

      if (bestCard && bestCard.media !== currentlyPlaying) {
        if (currentlyPlaying) {
          videoCards.forEach(function (item) {
            if (item.media === currentlyPlaying) {
              stopVideo(item.media, item.video);
            }
          });
        }
        playVideo(bestCard.media, bestCard.video);
        currentlyPlaying = bestCard.media;
      } else if (!bestCard && currentlyPlaying) {
        videoCards.forEach(function (item) {
          if (item.media === currentlyPlaying) {
            stopVideo(item.media, item.video);
          }
        });
        currentlyPlaying = null;
      }

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(onScrollCheck);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScrollCheck();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ft-showcase').forEach(initShowcase);
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.ft-showcase');
      if (section) initShowcase(section);
    });
  }
})();
